// extracted by mini-css-extract-plugin
export default {"IconButton":"kfp_4ons","red":"gdCbTBAb","green":"fbNFEAnb","black":"C3_Blelb","gray":"r84QNMoz","xs":"e9oSY7F_","s":"rJUBxBEY","m":"qFUsnSKe","l":"RKKELq3d"};